/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.3.0-nightly.2026.5.19",
    versionName: "0.3.0-nightly.2026.5.19",
    versionChannel: "nightly",
    buildDate: "2026-05-19T00:35:12.202Z",
    commitHash: "33a72d9cf138f8f04798ce054f94d8826b621e9f",
};
